// extracted by mini-css-extract-plugin
export default {"bounce":"Loading_bounce__F5vi8","bouncing":"Loading_bouncing__QSY9y","loadingContainer":"Loading_loadingContainer__tNPvY","loadingText":"Loading_loadingText__3+pnw"};